import React from "react";

import BrandMark from "../atoms/BrandMark";
import Container from "../atoms/Container";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-gray-200 py-10 dark:border-slate-700">
      <Container>
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
          <BrandMark />
          <p className="text-xs text-gray-500 dark:text-gray-500">
            © {year} Digar LLC. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
}
